import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";

import { PLANS_HIERARCHY, ROLE_HIERARCHY } from "../plans-permissions";

const CAN_DEBUG = process.env.REACT_APP_ENV === "development";

class FeatureRendererWrapper extends React.Component {
  static propTypes = {
    feature: PropTypes.shape({
      plan: PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
        helper: PropTypes.func,
      }),
    }),
    fallback: PropTypes.node,
    showUpgradePopup: PropTypes.bool,
    constraints: PropTypes.object,
  };

  static defaultProps = {
    user: {},
    showUpgradePopup: true,
    constraints: {},
  };

  state = {
    isPopupOpen: false,
  }

  tooglePopup = (value) => () => {
    const { isPopupOpen } = this.state;

    this.setState({ isPopupOpen: value || !isPopupOpen });
  }

  render() {
    const { isPopupOpen } = this.state;
    const {
      children,
      feature,
      fallback,
      user,
      constraints,
      showUpgradePopup,
      selectedOrganization,
      debug,
    } = this.props;

    const isOrganizationContext = !!selectedOrganization;

    const currentUserPlan = {
      plan: user.plan,
      appSumoCodes: user.appSumoCodes,
    };

    if (isOrganizationContext) {
      const { organization, appSumoCodes } = selectedOrganization;

      currentUserPlan.plan = organization.planId;
      currentUserPlan.appSumoCodes = appSumoCodes;
    }

    const featurePlanHierarchy = PLANS_HIERARCHY.findIndex(
      (plan) => plan.key === feature.plan.key
    );

    let userPlanHierarchy = PLANS_HIERARCHY.findIndex((plan) =>
      plan.helper({ user: currentUserPlan, organization: selectedOrganization })
    );

    // If, for any reason, the user plan doesn't match a plan from the
    // hierarchy it's set to "free" to avoid white screen
    if (userPlanHierarchy === -1) {
      userPlanHierarchy = PLANS_HIERARCHY.length - 1;
    }

    const userPlan = PLANS_HIERARCHY[userPlanHierarchy];

    let canRender =
      featurePlanHierarchy >= userPlanHierarchy && !constraints[userPlan.key];

    if (CAN_DEBUG && debug) {
      console.log("------RENDER------");
      console.log("=> user", user);
      console.log("=> feature", feature);
      console.log("=> isOrganizationContext", isOrganizationContext);
      console.log("=> originalUserPlan", {
        plan: user.plan,
        appSumoCodes: user.appSumoCodes,
      });
      console.log("=> currentUserPlan", currentUserPlan);
      console.log("=> featurePlanHierarchy", featurePlanHierarchy);
      console.log("=> userPlanHierarchy", userPlanHierarchy);
      console.log("=> userPlan", userPlan);
    }

    if (isOrganizationContext) {
      const featureRoleHierarchy = ROLE_HIERARCHY.findIndex(
        (role) => role.name === feature.role.name
      );

      const userRoleHierarchy = ROLE_HIERARCHY.findIndex(
        (role) => role.name === selectedOrganization.role.name
      );

      canRender = canRender && featureRoleHierarchy <= userRoleHierarchy;

      if (CAN_DEBUG && debug) {
        console.log("------ ROLE ------");
        console.log("=> featureRoleHierarchy", featureRoleHierarchy);
        console.log("=> userPlanHierarchy", userPlanHierarchy);
      }
    }

    if (CAN_DEBUG && debug) {
      console.log("=> canRender", canRender);
    }

    let wrappedComponent = children;

    if (
      canRender &&
      React.isValidElement(children) &&
      typeof children === "function"
    ) {
      wrappedComponent = React.cloneElement(children, {
        ...children.props,
        billingPlan: userPlan.key,
      });
    }

    let fallbackComponent = fallback;

    if (fallback && showUpgradePopup) {
      const fallbackPopupText = isOrganizationContext
        ? `You need to be "${feature.role.name}" of ${selectedOrganization.organization.name} to access this feature.`
        : `Click Here to Upgrade to the ${feature.plan.promptPlan} Plan.`;

      fallbackComponent = (
        <React.Fragment>
          <Popup
            trigger={
              <div onClick={this.tooglePopup(true)}>
                {fallback}
              </div>
            }
            on="click"
            open={isPopupOpen}
            onOpen={this.tooglePopup(true)}
            onClose={this.tooglePopup(false)}
            content={
              <div>
                <Link to={{ pathname: "/billing" }}>
                  {fallbackPopupText}
                </Link>
              </div>
            }
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {canRender ? wrappedComponent : fallback ? fallbackComponent : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.get("auth").get("user"),
    selectedOrganization: state.get("organization").get("selectedOrganization"),
  };
}

export const FeatureRenderer = connect(mapStateToProps)(FeatureRendererWrapper);



// WEBPACK FOOTER //
// ./src/hoc/FeatureRenderer.js